// create sessionId
export const SESSION_ID_CREATED = 'SESSION_ID_CREATED';

// add data to chat array
export const ADD_BACKEND_ANSWER_TO_CHAT = 'ADD_BACKEND_ANSWER_TO_CHAT';
export const ADD_USER_INPUT_TO_CHAT = 'ADD_INPUT_TO_CHAT';

// reset chat
export const RESET_CHAT_STATE = 'RESET_CHAT_STATE';
